import { CamelCaseKeys } from '@/common/types/snake-to-camel-case';
import { components } from '@/common/bag-api';
import { StopKind, Vehicle } from '@/new-transport/_models/transport.model';

export type TransportLogic = Omit<CamelCaseKeys<components['schemas']['TransportLogic']>, 'action'> & {
	action: StopKind;
};

export type TransportLogicPayload = Omit<TransportLogic, 'vehicle'> & {
	vehicle: TransportLogic['vehicle']['id'];
};

export type TransportTimetable = CamelCaseKeys<components['schemas']['Timetable']>;

export type TimetableCity = TransportTimetable['stop'];

export type TimetableVehicle = Vehicle & { transportVehicleKind: TransportVehicleKind };

export type TransportTableDataSource = TransportTimetable & {
	action: StopKind[];
	slotsCount: {
		boarding: number;
		dropOff: number;
	};
	isNotLastRow: boolean;
	isNotBeforeFinalTargetRow: boolean;
};

export interface GroupedTimetableByVehicle {
	vehicle: VehicleInGroupedTimetable;
	timetable: TransportTimetable[];
	transportLogic: TransportLogic[];
	antennasForVehicle: { vehicle: number; city: number }[];
}

export type VehicleInGroupedTimetable = TransportLogic['vehicle'] & { transportVehicleKind: TransportVehicleKind };

export interface GroupedTimetableByVehicleWithStopConnection extends Omit<GroupedTimetableByVehicle, 'timetable'> {
	timetable: TimetableWithStopConnection[];
}

export type TimetableWithStopConnection = TransportTimetable & { stopConnection: StopConnection };

export enum TransportVehicleKind {
	BUS = 'bus',
	ANTENNA = 'antenna',
}

export enum StopKindColor {
	BOARDING = '#ff1919',
	CRUISING = '#1f75fe',
	DROP_OFF = '#76b900',
	ADVANCED = '#ffde21',
	TARGET = '#8c21ff',
}

export type TimetableWithNestedAntennas = Omit<GroupedTimetableByVehicleWithStopConnection, 'antennasForVehicle'> & {
	antennasForVehicle: TimetableWithNestedAntennas[];
	editableVehicle: boolean;
};

export type StopConnection = CamelCaseKeys<components['schemas']['StopConnection']>;

export type TransportTerm = CamelCaseKeys<components['schemas']['TransportTerm']>;
